import _ from 'lodash';
import { engine } from '@/engine';
import { Constants } from '@/constants';
import { evaluate } from './helpers';

/* eslint-disable max-len */
/* Personal Details */
export const actionAgeNow = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.AgeNow${payload.modifier}`,
    value: evaluate(payload.value),
  });
};

export const actionSex = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.Sex${payload.modifier}`,
    value: evaluate(payload.value, 'string'),
  });
};

export const actionSalary = (store, payload) => {
  if (!store.state.inferred[`HasChangedSalary${payload.modifier}`].value) {
    store.commit('SET_STORE_VALUE', {
      key: `inferred.HasChangedSalary${payload.modifier}`,
      value: true,
    });
  }

  store.commit('SET_STORE_VALUE', {
    key: `inferred.Salary${payload.modifier}`,
    value: evaluate(payload.value),
  });
};

export const actionIncludePartner = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: 'inputs.IncludePartner',
    value: evaluate(payload.value, 'boolean'),
  });
};

/* Current Super */
export const actionEmployerType = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.EmployerType${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionMemberContributions = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.MemberContributions${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionPostTaxContributions = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.PostTaxContributions${payload.modifier}`,
    value: evaluate(payload.value, 'boolean'),
  });
};

export const actionEmployerContributionRate = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.EmployerContributionRate${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

/* Additional Super */
export const actionAccumulation = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.Accumulation${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionDefinedBenefit = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.DefinedBenefit${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionDeferredRetirementBalance = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.DeferredRetirementBalance${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionOtherFunds = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.OtherFunds${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

/* Additional contributions */
export const actionPreTaxMemberContributionsFrequency = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.PreTaxMemberContributionsFrequency${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionPreTaxMemberContributions = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.PreTaxMemberContributions${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionPostTaxMemberContributionsFrequency = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.PostTaxMemberContributionsFrequency${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionPostTaxMemberContributions = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.PostTaxMemberContributions${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionOneOffContribution = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.OneOffContribution${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionOneOffContributionMadeAtAge = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.OneOffContributionMadeAtAge${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

/* Investment mix */
export const actionInvestmentOption = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.InvestmentOption${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

/* Retirement Targets */
export const actionTargetIncome = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inferred.TargetIncome${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionRetirementAge = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.RetirementAge${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionRetirementAge2 = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.RetirementAge_2${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionRunOutAge = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.RunOutAge${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionWithdrawalAtRetirement = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.WithdrawalAtRetirement${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

/* Career Break */
export const actionPartTimeWorkFromAge = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.PartTimeWorkFromAge${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionPartTimeWorkYearsDuration = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.PartTimeWorkYearsDuration${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

export const actionPartTimeWorkDaysPerWeek = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.PartTimeWorkDaysPerWeek${payload.modifier}`,
    value: evaluate(payload.value, 'number'),
  });
};

/* Age Pension */
export const actionIncludeAgePension = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.IncludeAgePension${payload.modifier}`,
    value: evaluate(payload.value, 'boolean'),
  });
};

export const actionHomeOwner = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: `inputs.HomeOwner${payload.modifier}`,
    value: evaluate(payload.value, 'boolean'),
  });
};

export const actionOtherAssets = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: 'inputs.OtherAssets',
    value: evaluate(payload.value, 'number'),
  });
};

/* UI */
export const actionShowYourPartnerTab = ({ commit }, payload) => {
  commit('SET_UI_VALUE', {
    key: 'ui.showYourPartnerTab',
    value: evaluate(payload.value, 'boolean'),
  });
};

export const actionBreakdownShow = ({ commit }, payload) => {
  commit('SET_UI_VALUE', {
    key: 'ui.breakdown.show',
    value: evaluate(payload.value, 'boolean'),
  });
};

export const actionOverlayShow = ({ commit }, payload) => {
  commit('SET_UI_VALUE', {
    key: 'ui.overlay.show',
    value: evaluate(payload.value, 'boolean'),
  });
};

export const actionBreakdownAge = ({ commit }, payload) => {
  commit('SET_UI_VALUE', {
    key: 'ui.breakdown.age',
    value: evaluate(payload.value, 'number'),
  });
};

export const actionGraphType = ({ commit }, payload) => {
  commit('SET_UI_VALUE', {
    key: 'ui.graphType',
    value: evaluate(payload.value, 'string'),
  });
};

/* Editable Assumptions */
export const actionWageInflation = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: 'inferred.WageInflation',
    value: evaluate(payload.value),
  });
};

export const actionPriceInflation = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: 'inferred.PriceInflation',
    value: evaluate(payload.value),
  });
};

export const actionShowCustomInvestment = (store) => {
  // Set the custom investment option for all options
  actionInvestmentOption(store, { value: 6, modifier: '' });
  actionInvestmentOption(store, { value: 6, modifier: 'InRetirement' });
  actionInvestmentOption(store, { value: 6, modifier: Constants.PARAMETER_PARTNER_SUFFIX });
  actionInvestmentOption(store, { value: 6, modifier: `InRetirement${Constants.PARAMETER_PARTNER_SUFFIX}` });

  store.commit('SET_STORE_VALUE', {
    key: 'inferred.CustomOption',
    value: 5,
  });

  store.commit('SET_UI_VALUE', {
    key: 'ui.showCustomInvestment',
    value: true,
  });
};

function setCustomInvestmentProperty(key, value) {
  const custom = _.find(engine.params.getParamObject('InvestmentOptions').list, option => option.name === 'Custom');

  if (_.has(custom, key)) {
    _.set(custom, key, value);
  } else {
    /* eslint-disable */
    console.error(`custom investment does not have ${key} property`);
    /* eslint-enable */
  }
}

export const actionCustomOption = (store, payload) => {
  actionShowCustomInvestment(store);

  store.commit('SET_STORE_VALUE', {
    key: 'inferred.CustomOption',
    value: evaluate(payload.value),
  });
};

export const actionGrossReturn = (store, payload) => {
  setCustomInvestmentProperty('grossReturn', payload.value / 100);
  actionShowCustomInvestment(store);

  // console.log('actionGrossReturn', payload.value);

  store.commit('SET_STORE_VALUE', {
    key: 'inferred.GrossReturn',
    value: evaluate(payload.value),
  });
};

export const actionTaxableFraction = ({ commit }, payload) => {
  setCustomInvestmentProperty('taxableFraction', payload.value);
  commit('SET_STORE_VALUE', {
    key: 'inferred.TaxableFraction',
    value: evaluate(payload.value),
  });
};

export const actionFeePercentageOnBalance = (store, payload) => {
  setCustomInvestmentProperty('feePercentageOnBalance', payload.value / 100);
  actionShowCustomInvestment(store);

  store.commit('SET_STORE_VALUE', {
    key: 'inferred.FeePercentageOnBalance',
    value: evaluate(payload.value),
  });
};

export const actionFeePercentageOnBalanceCapped = (store, payload) => {
  setCustomInvestmentProperty('feePercentageOnBalanceCapped', payload.value / 100);
  actionShowCustomInvestment(store);

  store.commit('SET_STORE_VALUE', {
    key: 'inferred.FeePercentageOnBalanceCapped',
    value: evaluate(payload.value),
  });
};

export const actionFeePercentageOnBalanceCappedCap = (store, payload) => {
  setCustomInvestmentProperty('feePercentageOnBalanceCappedCap', +payload.value);
  actionShowCustomInvestment(store);

  store.commit('SET_STORE_VALUE', {
    key: 'inferred.FeePercentageOnBalanceCappedCap',
    value: evaluate(payload.value),
  });
};

export const actionFeePercentageOnContributions = (store, payload) => {
  setCustomInvestmentProperty('feePercentageOnContributions', payload.value / 100);
  actionShowCustomInvestment(store);

  store.commit('SET_STORE_VALUE', {
    key: 'inferred.FeePercentageOnContributions',
    value: evaluate(payload.value),
  });
};

export const actionFeeAnnualDollar = (store, payload) => {
  setCustomInvestmentProperty('feeAnnualDollar', +payload.value);
  actionShowCustomInvestment(store);

  store.commit('SET_STORE_VALUE', {
    key: 'inferred.FeeAnnualDollar',
    value: evaluate(payload.value),
  });
};

export const actionOverwriteDefaultInsuranceTable = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: 'inferred.OverrideFundDefaultInsurancePremiums',
    value: evaluate(payload.value, 'boolean'),
  });
  commit('SET_STORE_VALUE', {
    key: 'inputs.OverrideFundDefaultInsurancePremiums',
    value: evaluate(payload.value, 'boolean'),
  });
};

export const actionInsurancePremium = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: 'inferred.OverrideFundDefaultInsurancePremiums',
    value: true,
  });
  commit('SET_STORE_VALUE', {
    key: 'inputs.OverrideFundDefaultInsurancePremiums',
    value: true,
  });
  commit('SET_STORE_VALUE', {
    key: 'inferred.InsurancePremium',
    value: evaluate(payload.value),
  });
  commit('SET_STORE_VALUE', {
    key: 'inputs.InsurancePremium',
    value: evaluate(payload.value),
  });
};

export const actionUserSpecifiedDBAccrualRates = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: 'inputs.UserSpecifiedDBAccrualRates',
    value: evaluate(payload.value),
  });
  commit('SET_STORE_VALUE', {
    key: 'inferred.UserSpecifiedDBAccrualRates',
    value: evaluate(payload.value),
  });

  commit('SET_STORE_VALUE', {
    key: 'inputs.UserSpecifiedDBAccrualRates_2',
    value: evaluate(payload.value),
  });
  commit('SET_STORE_VALUE', {
    key: 'inferred.UserSpecifiedDBAccrualRates_2',
    value: evaluate(payload.value),
  });
};

export const actionUseSpecificDBAccrualRates = ({ commit }, payload) => {
  commit('SET_STORE_VALUE', {
    key: 'inputs.UseSpecificDBAccrualRates',
    value: evaluate(payload.value, 'boolean'),
  });
  commit('SET_STORE_VALUE', {
    key: 'inferred.UseSpecificDBAccrualRates',
    value: evaluate(payload.value, 'boolean'),
  });

  commit('SET_STORE_VALUE', {
    key: 'inputs.UseSpecificDBAccrualRates_2',
    value: evaluate(payload.value, 'boolean'),
  });
  commit('SET_STORE_VALUE', {
    key: 'inferred.UseSpecificDBAccrualRates_2',
    value: evaluate(payload.value, 'boolean'),
  });
};
